export enum AnalyticEventName {
  CLICK_SEARCH = 'ClickSearch',
  CLICK_ONLINE_CHAT = 'ClickOnlineChat',
  CLICK_CLIENT_NAME = 'ClickClientName',
  CLICK_MANAGE_PROFILE = 'ClickManageProfile',
  CLICK_LOGOUT = 'ClickLogout',
  CLICK_INTERNET_ORDER = 'ClickInternetOrder',
  CLICK_CONNECT_ONLINE_STORE = 'ClickConnectOnlineStore',
  CONNECT_ONLINE_STORE_SUCCESS = 'ConnectOnlineStoreSuccess',
  CLICK_FILTERS = 'ClickFilters',
  CLICK_APPLY_FILTERS = 'ClickApplyFilters',
  CLICK_CANCEL_FILTERS = 'ClickCancelFilters',
  CLICK_FORWARDING_REQUEST = 'ClickForwardingRequest',
  SUBMIT_FORWARDING = 'SubmitForwarding',
  FORWARDING_SUCCESS = 'ForwardingSuccess',
  CLICK_EDIT_FORWARDING_REQUEST = 'ClickEditForwardingRequest',
  SUBMIT_EDIT_FORWARDING = 'SubmitEditForwarding',
  EDIT_FORWARDING_SUCCESS = 'EditForwardingSuccess',
  CLICK_CHANGE_DATA_REQUEST = 'ClickChangeDataRequest',
  SUBMIT_CHANGE_DATA = 'SubmitChangeData',
  CHANGE_DATA_SUCCESS = 'ChangeDataSuccess',
  CLICK_RETURN_REQUEST = 'ClickReturnRequest',
  SUBMIT_RETURN = 'SubmitReturn',
  RETURN_SUCCESS = 'ReturnSuccess',
  CLICK_EDIT_RETURN_REQUEST = 'ClickEditReturnRequest',
  SUBMIT_EDIT_RETURN = 'SubmitEditReturn',
  EDIT_RETURN_SUCCESS = 'EditReturnSuccess',
  CLICK_STORAGE_PROLONGATION_REQUEST = 'ClickStorageProlongationRequest',
  SUBMIT_STORAGE_PROLONGATION = 'SubmitStorageProlongation',
  STORAGE_PROLONGATION_SUCCESS = 'StorageProlongationSuccess',
  CLICK_EASY_RETURN = 'ClickEasyReturn',
  SUBMIT_EASY_RETURN = 'SubmitEasyReturn',
  EASY_RETURN_SUCCESS = 'EasyReturnSuccess',
  CLICK_APPLICATION_REQUEST = 'ClickApplicationRequest',
  CLICK_PAY = 'ClickPay',
  CLICK_MUTUAL_SETTLEMENTS = 'ClickMutualSettlements',
  CLICK_RECONCILIATION_ACT = 'ClickReconciliationAct',
  CLICK_PRIMARY_DOCUMENTS_PACKAGE = 'ClickPrimaryDocumentsPackage',
  CLICK_REPORTING = 'ClickReporting',
  CLICK_REPORT_FOR_PERIOD = 'ClickReportForPeriod',
  CLICK_REPORT_TO_MAIL = 'ClickReportToMail',
  CLICK_ORDER_COPIES = 'ClickOrderCopies',
  SUBMIT_ORDER_COPIES = 'SubmitOrderCopies',
  ORDER_COPIES_SUCCESS = 'OrderCopiesSuccess',
  CLICK_MAKE_CONTRACT = 'ClickMakeContract',
  CLICK_SEND_APPLICATION_ONLINE = 'ClickSendApplicationOnline',

  CREATE_PARCEL_FIRST_STEP = 'CreateParcelFirstStep',
  CREATE_PARCEL_SECOND_STEP = 'CreateParcelSecondStep',
  CREATE_PARCEL_SUCCESS = 'CreateParcelSuccess',
  CREATE_PARCEL_CLOSE = 'CreateParcelClose',

  TABLE_REFRESH = 'TableRefresh',
  TABLE_DOWNLOAD = 'TableDownload',
  TABLE_FILTERS_APPLY = 'TableFiltersApply',
  TABLE_CUSTOMIZE = 'TableCustomize',
  TABLE_SORT = 'TableSort',

  // Fulfilment events
  CREATE_ORDER = 'CreateOrder',
  CREATE_ORDER_SUCCESS = 'CreateOrderSuccess',

  // Delivery events
  CLICK_MAKE_CONTRACT_HEADER = 'ClickMakeContractInHeader'
}

export interface IAnalyticsEvent {
  name: AnalyticEventName;
  data?: IAnalyticsEventData
}

export enum EAnalyticsDataKey {
  NUMBER = 'number',
  DURATION = 'duration',
  SECTION = 'section',
  TRIGGER = 'trigger',
  DOCUMENTS = 'documents',
  ARTICLE = 'article',
  DELIVERY = 'delivery',
}

export interface IAnalyticsEventData {
  [EAnalyticsDataKey.NUMBER]?: string;
  [EAnalyticsDataKey.DURATION]?: number;
  [EAnalyticsDataKey.SECTION]?: string;
  [EAnalyticsDataKey.TRIGGER]?: string;
  [EAnalyticsDataKey.DOCUMENTS]?: boolean;
  [EAnalyticsDataKey.ARTICLE]?: number;
  [EAnalyticsDataKey.DELIVERY]?: string;
}
